import { useContext, useEffect, useMemo, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { DateObject } from "react-multi-date-picker";
import { convertTo12HourFormat, dateConvert, dateHoverRange, timeStringToDate } from "../../../utils/Helper";
import axios from "axios";
import _ from "underscore";
import { callautopopulate } from "../../../services/callautopop";
import { ToastContext } from "../../../context/ToastContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { decryptData } from "../../../utils/encrypt";
import { useLateArrival } from "../Punctuality/useLateArrival";

export const useTaptik = ({ userId }) => {

    const { showError, showSuccess, showInfo } = useContext(ToastContext);
    const [taptikData, setTaptikData] = useState({ first: "", last: "", inOffice: "no" });
    const [showHistory, setShowHistory] = useState(false);
    const [loggedInUser, setLoggedInUser] = useState({ data: {}, user_code: 0 });
    const [loader, setLoader] = useState({ I: false, O: false, BI: false, BO: false });
    const [gridLoader, setGridLoader] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [colDef] = useState([
        {
            field: "srno",
            headerName: "S.No",
            flex: 1,
            cellStyle: { textAlign: "center" }
        },
        {
            field: "shift_date",
            headerName: "Shift Date",
            flex: 2,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && dateConvert(params?.value, "day-month-year")}</div>
                )
            }
        },
        {
            field: "shift_start_time",
            headerName: "Shift In",
            headerClass: "header-wrap",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "shift_end_time",
            headerName: "Shift Out",
            headerClass: "header-wrap",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "actual_starttime",
            headerName: "Punch In",
            headerClass: "header-wrap",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div className={params?.data?.is_punctual_in_time === 1 ? "text-success" : "text-danger"}>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "actual_endtime",
            headerName: "Punch Out",
            headerClass: "header-wrap",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div className={params?.data?.is_punctual_out_time === 1 ? "text-success" : "text-danger"}>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "insights_starttime",
            headerName: "Tap In",
            headerClass: "header-wrap",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div className={params?.data?.is_punctual_in_time === 1 ? "text-success" : "text-danger"}>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "insights_endtime",
            headerName: "Tap Out",
            headerClass: "header-wrap",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div className={params?.data?.is_punctual_out_time === 1 ? "text-success" : "text-danger"}>{params?.value && convertTo12HourFormat(params?.value)}</div>
                )
            }
        },
        {
            field: "total_breaks",
            headerName: "Break Count",
            headerClass: "header-wrap",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    params?.value ?
                        <div className="text-decoration-underline c-pointer" onClick={() => setBreakDetails((prev) => ({ ...prev, visible: true, data: params?.data?.breakData, date: dateConvert(params?.data?.shift_date, "day-month-year") }))}>{params?.value}</div>
                        : <></>
                )
            }
        },
        {
            field: "break_duration_hrs",
            headerName: "Break Hours",
            flex: 1,
            cellStyle: { textAlign: "center" },
            headerClass: "header-wrap",
            cellRenderer: (params) => {
                return (
                    params?.data?.total_breaks ?
                        <div>{params?.value}</div>
                        : <></>
                )
            }
        },
        {
            field: "working_hours",
            headerName: "Working Hours",
            flex: 1,
            cellStyle: { textAlign: "center" },
            headerClass: "header-wrap"
        },
        {
            field: "extra_hours",
            headerName: "Extra Hours",
            flex: 1,
            cellStyle: { textAlign: "center" },
            headerClass: "header-wrap",
        },
        {
            field: "deficit",
            headerName: "Deficit",
            flex: 1,
            cellStyle: { textAlign: "center" },
        },
        {
            field: "unpunctual",
            headerName: "UnPunctual",
            flex: 1,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            valueGetter: (params) => {
                const isUnpunct = ((params?.data?.is_punctual_in_time === 0 || params?.data?.is_punctual_out_time === 0) && (params?.data?.actual_starttime || params?.data?.actual_endtime)) ? 1 : 0
                return isUnpunct;
            },
            cellRenderer: (params) => {
                return (
                    <div>{((params?.data?.is_punctual_in_time === 0 || params?.data?.is_punctual_out_time === 0) && (params?.data?.actual_starttime || params?.data?.actual_endtime)) && <FontAwesomeIcon icon="fa-solid fa-circle-check" className="text-danger" />}</div>
                )
            }
        },
        {
            field: "is_regularize",
            headerName: "REG",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.data?.is_regularize === 1 && <FontAwesomeIcon icon="fa-solid fa-circle-check" className="text-warning" />}</div>
                )
            }
        },
        {
            field: "is_gatepass_applied",
            headerName: "Gate Pass",
            flex: 1,
            headerClass: "header-wrap",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.data?.is_gatepass_applied === 1 && <FontAwesomeIcon icon="fa-solid fa-circle-check" className="text-success" />}</div>
                )
            }
        },
        {
            field: "is_wfh",
            headerName: "WFH",
            flex: 1,
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <div>{params?.data?.is_wfh === 1 && <FontAwesomeIcon icon="fa-solid fa-circle-check" className="text-success" />}</div>
                )
            }
        },
    ]);
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const [hoveredRange, setHoveredRange] = useState([new DateObject(firstDay), new DateObject(lastDay)]);
    const [isDateChange, setIsDateChange] = useState(false);
    const [reasonList, setReasonList] = useState([]);
    const [showConfirmation, setShowConfirmation] = useState({ visible: false, type: "", ask_reason: false });
    const [remark, setRemark] = useState({ selected: {}, entered: "" })
    const [currentUser] = useState(decryptData(sessionStorage.getItem("user_code")))
    const [selectedData] = useState({});
    const { handleSubmitReason } = useLateArrival({ selectedData, currentUser });
    const [breakDetails, setBreakDetails] = useState({ visible: false, data: [], date: null })

    useEffect(() => {
        if (userId) {
            setLoggedInUser((prev) => ({ ...prev, user_code: userId }));
        } else {
            callautopopulate("user_info", "unpunctuality_reasons")?.then(res => {
                setLoggedInUser((prev) => ({ ...prev, data: res?.user_info?.[0], user_code: res?.user_info?.[0]?.user_code }));
                setReasonList(res?.unpunctuality_reasons)
            })
        }

    }, [])

    useEffect(() => {
        if (hoveredRange?.[0] && hoveredRange?.[1] && loggedInUser?.user_code !== 0) {
            getTaptikDetails();
        }
    }, [loggedInUser?.user_code])

    useEffect(() => {
        const taptikDialog = document.getElementsByClassName("taptik-dialog");
        const content = document.getElementsByClassName("content-class");
        const sidebar = document.getElementsByClassName("sidebar-main-menu");
        if (showConfirmation?.ask_reason) {
            document.body.addEventListener('touchstart', handleBlockUI, true);
            taptikDialog?.[0]?.addEventListener('mousemove', handleBlockUI, true);
            content?.[0]?.addEventListener('mousemove', handleBlockUI, true);
            sidebar?.[0]?.addEventListener('mousemove', handleBlockUI, true);
        }
        return () => {
            document.body.removeEventListener('touchstart', handleBlockUI, true);
            taptikDialog?.[0]?.removeEventListener('mousemove', handleBlockUI, true);
            content?.[0]?.removeEventListener('mousemove', handleBlockUI, true);
            sidebar?.[0]?.removeEventListener('mousemove', handleBlockUI, true);
        };
    }, [showConfirmation?.ask_reason]);

    const getTaptikDetails = async (key) => {
        try {
            setGridLoader(true);
            let from = "";
            let to = "";
            if (!hoveredRange?.[0] && !hoveredRange?.[1]) {
                from = dateHoverRange(new DateObject());
                to = dateHoverRange(new DateObject());
            } else if (hoveredRange?.[0] && hoveredRange?.[1]) {
                from = dateHoverRange(hoveredRange?.[0]);
                to = dateHoverRange(hoveredRange?.[1]);
            } else {
                setRowData([])
                setGridLoader(false);
                return
            }
            const payload = {
                "from_date": from,
                "to_date": to,
                "requested_user_code": loggedInUser?.user_code
            }
            const res = await services.getInvokeRemote("POST", Urls("GETTAPTIKDETAILS"), payload);
            if (res) {
                const data = res?.body?.data?.taptik_data;
                const shiftData = res?.body?.data?.monthly_taptik_data;
                const breakData = res?.body?.data?.employee_shift;

                const todaysData = _.filter(data, item => dateConvert(new Date(item?.shift_date)) === dateConvert(new Date()));
                if (!_.isEmpty(todaysData)) {
                    const todaysBreakData = _.filter(breakData, br => dateConvert(new Date(br?.shift_date)) === dateConvert(new Date()));
                    let disabled = todaysData?.[0]?.is_inOffice !== null || todaysData?.[0]?.is_wfh
                    let inOffice = todaysData?.[0]?.is_wfh ? "no" : todaysData?.[0]?.is_inOffice ? "yes" : "no";
                    const lastBreak = _.sortBy(todaysBreakData, "break_in")?.[todaysBreakData?.length - 1];
                    let taptikData = {
                        inOffice, disabled,
                        first: convertTo12HourFormat(todaysData?.[0]?.insights_starttime),
                        last: convertTo12HourFormat(todaysData?.[0]?.insights_endtime),
                        lastBreak: todaysBreakData?.length > 0 ? { ...lastBreak, break_in: convertTo12HourFormat(lastBreak?.break_in), break_out: convertTo12HourFormat(lastBreak?.break_out) } : {}
                    }
                    setTaptikData(taptikData);
                }
                let shift_start = shiftData?.[0]?.shift_start_time || "09:00:00";
                if (key === "I" && todaysData?.[0]?.insights_starttime > shift_start) {
                    const shiftDate = timeStringToDate(shift_start);
                    const actualDate = timeStringToDate(todaysData?.[0]?.insights_starttime);
                    if ((actualDate?.getHours() > shiftDate?.getHours()) || (actualDate?.getHours() === shiftDate?.getHours() && Math.abs(actualDate?.getMinutes() - shiftDate?.getMinutes()) > 6)) {
                        setShowConfirmation((prev) => ({ ...prev, visible: true, type: "I", ask_reason: true }));
                    } else {
                        setShowConfirmation((prev) => ({ ...prev, visible: true, type: "I", ask_reason: false }));
                    }
                } else if (key === "O" && shiftData?.[0]?.shift_end_time > todaysData?.[0]?.insights_endtime) {
                    setShowConfirmation((prev) => ({ ...prev, visible: true, type: "O", ask_reason: true }));
                }
                setRowData(data?.map((item, index) => { return { ...item, srno: index + 1, breakData: _.filter(breakData, br => dateConvert(new Date(br?.shift_date)) === dateConvert(new Date(item?.shift_date))) } }));
                setGridLoader(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            setGridLoader(false);
        }
    }

    const upsertTaptik = async (key) => {
        try {
            if (loader?.[key]) return;
            setLoader((prev) => ({ ...prev, [key]: true }));
            const getIp = await axios.get(`https://api.ipify.org?format=json&t=${Date.now()}`);
            const ip = getIp.data.ip
            const payload = {
                "tik_type": key,
                "ip_address_name": ip,
                "is_inOffice": taptikData?.inOffice === "yes"
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTTAPTIKINOUT"), payload);
            if (res?.body?.error_status) {
                showError("Error", res?.body?.message);
                setLoader((prev) => ({ ...prev, [key]: false }));
            } else {
                showSuccess("Success", res?.body?.message);
                getTaptikDetails(key);
                setLoader((prev) => ({ ...prev, [key]: false }));
                setShowConfirmation((prev) => ({ ...prev, visible: false, type: "" }));
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader((prev) => ({ ...prev, [key]: false }));
            showError("Error", error?.response?.data?.errorMessage);
            setShowConfirmation((prev) => ({ ...prev, visible: false, type: "" }));
        }
    }

    const sendRemark = async () => {
        try {
            if (_.isEmpty(remark?.selected)) {
                showInfo("Info", "Please select a remark");
                return;
            }
            const payloadObj = {
                "employee_id": loggedInUser?.data?.employee_id,
                "shift_date": rowData?.[0]?.shift_date || "",
                "shift_startdate": rowData?.[0]?.shift_startdate || "09:00:00",
                "shift_enddate": rowData?.[0]?.shift_enddate || "",
                "in_time": rowData?.[0]?.insights_starttime || "",
                "out_time": rowData?.[0]?.insights_endtime || "",
                "in_reason_id": showConfirmation?.type === "I" ? remark?.selected?.reason_id : (showConfirmation?.type === "O" ? rowData?.[0]?.in_reason_id : 0) || 0,
                "out_reason_id": showConfirmation?.type === "O" ? remark?.selected?.reason_id : 0 || 0,
                "in_remark": showConfirmation?.type === "I" ? (remark?.selected?.reason_type_key === "other" ? remark?.entered : remark?.selected?.reasons) : (showConfirmation?.type === "O" ? rowData?.[0]?.in_remark : "") || "",
                "out_remark": showConfirmation?.type === "O" ? (remark?.selected?.reason_type_key === "other" ? remark?.entered : remark?.selected?.reasons) : ""
            }
            const taptikType = { type: showConfirmation?.type, selected_remark: remark?.selected }
            const success = await handleSubmitReason(false, payloadObj, null, true, taptikType);
            if (success) {
                setShowConfirmation({ visible: false, type: "", ask_reason: false });
            }
        } catch (error) {
            console.error("Error saving remark: ", error);
        }
    }

    const handleBlockUI = () => {
        setShowConfirmation((prev) => ({ ...prev, visible: true }));
        const elements = document.getElementsByClassName("p-dialog-mask");
        if (elements[0]?.style?.display) {
            elements[0].style.display = "flex";
        }
        if (elements[1]?.style?.display) {
            elements[1].style.display = "flex";
        }
        return;
    }

    return useMemo(() => ({
        taptikData, colDef, rowData, setRowData, showHistory, setShowHistory, upsertTaptik, hoveredRange, setHoveredRange, loader, getTaptikDetails, gridLoader, isDateChange, setIsDateChange, showConfirmation, setShowConfirmation, reasonList, remark, setRemark, sendRemark, setTaptikData, breakDetails, setBreakDetails
    }), [taptikData, colDef, rowData, setRowData, showHistory, setShowHistory, upsertTaptik, hoveredRange, setHoveredRange, loader, getTaptikDetails, gridLoader, isDateChange, setIsDateChange, showConfirmation, setShowConfirmation, reasonList, remark, setRemark, sendRemark, setTaptikData, breakDetails, setBreakDetails])
}